import { render, staticRenderFns } from "./QuoteOptionsByStatus.vue?vue&type=template&id=47c3270b&scoped=true"
import script from "./QuoteOptionsByStatus.vue?vue&type=script&lang=js"
export * from "./QuoteOptionsByStatus.vue?vue&type=script&lang=js"
import style0 from "./QuoteOptionsByStatus.vue?vue&type=style&index=0&id=47c3270b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3270b",
  null
  
)

export default component.exports